export default __webpack_public_path__ + "static/media/MobileView.9501e504.png";